// Legge prima dalla config runtime (per multi-ambiente), poi fallback su env var
export const API_URL = window.APP_CONFIG?.API_URL ?? process.env.REACT_APP_BASEURL ?? ""

export const AUTH_MODE: "development" | "production" = window.APP_CONFIG?.MODE ?? "development"
export const DEV_USER: string = window.APP_CONFIG?.DEV_USER ?? ""
export const DEV_PASSWORD: string = window.APP_CONFIG?.DEV_PASSWORD ?? ""
export const DEV_AZIENDA: string = window.APP_CONFIG?.DEV_AZIENDA ?? ""

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const response = await fetch(`${API_URL}${path}`, {
    headers: {
      "Content-Type": "application/json",
      ...(options.headers ?? {}),
    },
    ...options,
  })

  if ((await response.clone().text()).trim().startsWith("<")) {
    throw new Error("Invalid API response")
  }

  if (!response.ok) {
    const message = await response.text()
    throw new Error(message || response.statusText)
  }

  return (await response.json()) as Promise<T>
}
